import React, { useState } from "react";
import { Alert, Box, Button, CircularProgress, TextField } from "@mui/material";
import { usePasswordUpdate } from "../../hooks/usePasswordUpdate";
import { formContainer } from "./styles";

/**
 * UpdatePasswordForm
 *
 * Renders a form for updating the user's password.
 * Handles form state, validation, and submission.
 * Displays loading, error, and success states.
 */
export default function UpdatePasswordForm() {
  // Hook for API status and password update function
  const { status, clearStatus, send } = usePasswordUpdate();

  // Local state for password fields
  const [password, setPassword] = useState("");
  const [password_confirmation, setPasswordConfirmation] = useState("");

  /**
   * Handles form submission.
   * Calls the password update API and resets fields on success.
   */
  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    clearStatus();
    try {
      await send({ password, password_confirmation });
      if (!status.error) {
        setPassword("");
        setPasswordConfirmation("");
      }
    } catch (err) {
      // Log error for debugging
      console.error("Password update error:", err);
    }
  };

  return (
    <Box component="form" onSubmit={onSubmit} sx={formContainer}>
      {/* Error message */}
      {status.error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {status.error}
        </Alert>
      )}
      {/* Success message */}
      {status.success && (
        <Alert severity="success" sx={{ mb: 2 }}>
          {status.success}
        </Alert>
      )}
      {/* Loading indicator */}
      {status.loading && <CircularProgress sx={{ mb: 2 }} />}

      <TextField
        label="New Password"
        type="password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        fullWidth
        margin="normal"
        required
      />
      <TextField
        label="Confirm Password"
        type="password"
        value={password_confirmation}
        onChange={(e) => setPasswordConfirmation(e.target.value)}
        fullWidth
        margin="normal"
        required
      />

      <Button
        type="submit"
        variant="contained"
        sx={{ mt: 2 }}
        disabled={status.loading}
      >
        Update
      </Button>
    </Box>
  );
}
